module.exports = __webpack_public_path__ + "img/cleaf4.e247a8f7.jpg";